import * as React from 'react';
import { Inject, Subscribe } from '@symbiotic/green-state';

import { PortalFramework } from '../framework/PortalFramework';
import { Toaster } from './Toaster';
import { AppRouter } from './AppRouter';

export const App = () => (
  <>
    <Inject diKey={PortalFramework}>
      {(portalFramework) => (
        <Subscribe to={() => portalFramework.toaster}>
          {({ toasts }) => (
            <Toaster toasts={toasts} />
          )}
        </Subscribe>
      )}
    </Inject>

    <AppRouter />
  </>
);



// WEBPACK FOOTER //
// ./src/portal-react-app/App.tsx